module.exports = __webpack_public_path__ + "eb896d1fa652f3677a229f5942b9da85.svg";